import React from 'react';

import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { PageBreadcrumbs } from 'components/common/PageBreadcrumbs/PageBreadcrumbs';

import { Button } from 'components/DesignSystem/Button';

import classes from './CreateReportPageHeader.module.scss';

export const CreateReportPageHeader = () => {
    const history = useHistory();

    const onCancel = () => {
        history.replace({
            pathname: AppRoutes.buildPath(AppRoutes.DASHBOARD_REPORTING_PATH),
        });
    };
    return (
        <div className={classes.CreateReportPageHeader}>
            <div className={classes.row}>
                <PageBreadcrumbs
                    items={[
                        {
                            label: 'Reports',
                            to: AppRoutes.buildPath(AppRoutes.DASHBOARD_REPORTING_PATH),
                            noEllipsis: true,
                        },
                        { label: 'Create new', noEllipsis: true },
                    ]}
                />

                <Button variant={'secondary'} onClick={onCancel}>
                    Cancel
                </Button>
            </div>
        </div>
    );
};
